exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-list-item[data-v-bc528874]{margin-bottom:20px}.pagination[data-v-bc528874]{margin-top:20px;text-align:center}.card-list-loading-container[data-v-bc528874]{position:absolute;top:50%;width:100%;text-align:center}.add-content-wrapper[data-v-bc528874]{height:125px;width:100%}.add-content-wrapper .add-content[data-v-bc528874]{text-align:center;line-height:125px;font-size:16px;cursor:pointer;color:#2a82e4;display:block}", ""]);

// exports
